import React, { useState, useEffect, FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { CompanyDetailEventsProps as Props } from './types';
import { getCompanyEvents } from '../../../services/companies';

export const Component: FunctionComponent<Props> = (props) => {
  const [eventIds, setEventIds] = useState<number[]>([]);

  useEffect(() => {
    let aborted = false;

    const fetchEvents = async () => {
      try {
        const response = await getCompanyEvents(props.company.id);
        if (aborted) return;
        setEventIds(response.eventIds ?? []);
        props.setIdCount('eventIds', (response.eventIds ?? []).length);
      } catch (error) {
        console.log(error);
      }
    };

    fetchEvents();
    return () => {
      aborted = true;
    };
  }, [props.company.id, props.setIdCount]);

  return (
    <Presentation
      eventIds={eventIds}
      companyId={props.company.id}
      coverNoImg={props.coverNoImg}
      dataCategory={props.dataCategory}
      dataValue={props.dataValue}
    />
  );
};
